import { render, staticRenderFns } from "./MealOption.vue?vue&type=template&id=2dc81853&lang=pug&"
import script from "./MealOption.vue?vue&type=script&lang=js&"
export * from "./MealOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports